import { put, takeLatest, call } from "redux-saga/effects";

import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import * as actions from "./actions";
import * as types from "./types";
import * as apis from "../../network/apis/employees";
import { ROUTE_PATHS } from "../../utils/RoutesPaths";
import { deleteBlob } from "../../utils/blobStorageServices";

function* employeesListSaga({ payload }) {
  try {
    const response = yield call(apis.employeesList, payload);
    const { Items, CurrentPage, ItemCount, TotalPages } =
      response.data.Data;
    yield put(
      actions.employeesListResponse({
        list: Items,
        meta: {
          currentPage: +CurrentPage,
          count: +ItemCount,
          pages: +TotalPages
        }
      })
    );
    if (CurrentPage && TotalPages && +CurrentPage > +TotalPages) {
      yield put(
        actions.employeesListRequest({
          ...payload,
          page: +TotalPages
        })
      );
    }
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* addEmployeeSaga({ payload }) {
  try {
    const { data, dbData, navigate } = payload;
    yield call(apis.addEmployee, data);
    yield showSuccessMsg("employeeAddedSuccessfully");
    yield navigate(ROUTE_PATHS.employeesList);
    if (dbData.EmployeeImageIsNew && !!dbData.dbEmployeeImage) {
      yield deleteBlob(
        dbData.dbEmployeeImage?.split("/images/")[1],
        "images"
      );
    }
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
    const { data, dbData } = payload;
    if (dbData.EmployeeImageIsNew && !!data?.EmployeeImage) {
      yield deleteBlob(data?.EmployeeImage, "images");
    }
  }
}

function* getEmployeeDetailsSaga({ payload }) {
  try {
    const response = yield call(apis.employeeDetails, {
      id: payload
    });
    yield put(actions.getEmployeeDetailsResponse(response.data.Data));
  } catch (error) {
    yield error?.response?.data?.Message &&
      showErrorMsg(error.response.data?.Message);
  }
}

function* editEmployeeSaga({ payload }) {
  try {
    const { data, navigate } = payload;
    yield call(apis.editEmployee, data);
    yield showSuccessMsg("editEmployeeSuccess");
    yield navigate(ROUTE_PATHS.employeesList);
  } catch (error) {
    yield error?.response?.data?.Message &&
      showErrorMsg(error.response.data?.Message);
  }
}

function* activateEmployeeSaga({ payload }) {
  try {
    yield call(apis.activateEmployee, payload);
    yield showSuccessMsg("reactivateEmployeeSuccess");
    yield put(actions.getEmployeeDetailsRequest(payload.id));
  } catch (error) {
    yield error?.response?.data?.Message &&
      showErrorMsg(error.response.data?.Message);
  }
}

function* deactivateEmployeeSaga({ payload }) {
  try {
    yield call(apis.deactivateEmployee, payload);
    yield showSuccessMsg("deactivateEmployeeSuccess");
    yield put(actions.getEmployeeDetailsRequest(payload.id));
  } catch (error) {
    yield error?.response?.data?.Message &&
      showErrorMsg(error.response.data?.Message);
  }
}

export default function* EmployeesSagas() {
  yield takeLatest(types.EMPLOYEES_LIST_REQUEST, employeesListSaga);
  yield takeLatest(types.ADD_EMPLOYEE_REQUEST, addEmployeeSaga);
  yield takeLatest(
    types.GET_EMPLOYEE_DETAILS_REQUEST,
    getEmployeeDetailsSaga
  );
  yield takeLatest(types.EDIT_EMPLOYEE_REQUEST, editEmployeeSaga);
  yield takeLatest(
    types.ACTIVATE_EMPLOYEE_REQUEST,
    activateEmployeeSaga
  );
  yield takeLatest(
    types.DEACTIVATE_EMPLOYEE_REQUEST,
    deactivateEmployeeSaga
  );
}
